import React from "react";
import { Button, Upload } from "antd";
import { getBase64 } from "../lib/helpers";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import StepButton from "./StepButton";

const UploadComponent = ({ files, onChange }) => {
  const handleMediaChange = (file, fileList) => {
    const filesPromises = fileList.map(
      (file, idx) =>
        new Promise((resolve) => {
          getBase64(file, (url) => {
            resolve({
              name: file.name,
              uid: file.uid,
              size: file.size,
              url,
              pos: idx,
            });
          });
        }),
    );

    Promise.all(filesPromises).then((files) => {
      onChange(files);
    });

    return false;
  };

  return (
    <Upload
      className="w-full"
      listType="picture"
      multiple
      accept=".png,.jpg,.jpeg,.gif"
      beforeUpload={handleMediaChange}
      fileList={files}
      itemRender={(originNode, file) => {
        void originNode;
        return (
          <div className="flex items-center gap-2 mt-2 border p-2 rounded">
            <img
              src={file.url}
              alt={file.name}
              className="w-8 h-8 object-cover"
            />
            <span className="text-xs grow">{file.name}</span>

            <StepButton
              value={file.pos}
              step={1}
              min={0}
              showValue={false}
              onChange={(value) => {
                const newFiles = files.map((f) => {
                  if (f.uid === file.uid) {
                    return {
                      ...f,
                      pos: value,
                    };
                  }
                  return f;
                });
                onChange(newFiles);
              }}
              type="number"
            />

            <Button
              type="text"
              size="small"
              icon={<DeleteOutlined />}
              onClick={() => {
                const newFiles = files.filter((f) => f.uid !== file.uid);
                onChange(newFiles);
              }}
            />
          </div>
        );
      }}
    >
      <Button>
        <PlusOutlined />
        Upload
      </Button>
    </Upload>
  );
};

export default UploadComponent;
